var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbusingRoles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.19 17.47C17.47 17.79 17 18.51 17 19.3V24C17 29.55 20.84 34.74 26 36C31.16 34.74 35 29.55 35 24V19.3C35 18.51 34.53 17.79 33.81 17.47L26.81 14.36C26.29 14.13 25.7 14.13 25.19 14.36L18.19 17.47ZM26 20C26.55 20 27 20.45 27 21C27 21.55 26.55 22 26 22C25.45 22 25 21.55 25 21C25 20.45 25.45 20 26 20ZM26 24C26.55 24 27 24.45 27 25V29C27 29.55 26.55 30 26 30C25.45 30 25 29.55 25 29V25C25 24.45 25.45 24 26 24Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbusingRoles);
export default __webpack_public_path__ + "static/media/abusing_roles.e92690d0c2217ca69ef11db027489779.svg";
export { ForwardRef as ReactComponent };